import React, { Suspense, lazy, useMemo } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import LockCard from './locked/LockCard';
import GenericPreview from './locked/previews/generic';

// Map of feature keys → lazy preview component imports.
// To add a new preview: drop a file at views/locked/previews/<key>.jsx and add an entry here.
const PREVIEWS = {
    ait: () => import('./locked/previews/ait'),
    profitability: () => import('./locked/previews/profitability'),
};

export default function LockedFeaturePage() {
    const { featureKey } = useParams();
    const { currentUser, canAccess, isLocked, getLockReason } = useAuth();

    if (canAccess(featureKey)) {
        const path = featureKey.replace(/_/g, '-');
        return <Navigate to={`/dashboard/${path}`} replace />;
    }
    if (!isLocked(featureKey)) return <Navigate to="/dashboard" replace />;

    const feature = currentUser.lockedFeatures.find(f => f.key === featureKey);
    const reason = getLockReason(featureKey);

    const Preview = useMemo(() => {
        const loader = PREVIEWS[featureKey];
        if (!loader) return null;
        return lazy(() => loader().catch(() => ({ default: () => <GenericPreview featureName={feature?.name} /> })));
    }, [featureKey, feature?.name]);

    if (!feature) return <Navigate to="/dashboard" replace />;

    return (
        <div className="relative h-full overflow-hidden">
            <div className="absolute inset-0 blur-sm opacity-40 pointer-events-none">
                <Suspense fallback={<GenericPreview featureName={feature.name} />}>
                    {Preview ? <Preview /> : <GenericPreview featureName={feature.name} />}
                </Suspense>
            </div>
            <LockCard featureName={feature.name} reason={reason} />
        </div>
    );
}
